import { ToggleGroup } from "@design-system/ToggleGroup/ToggleGroup";
import { ArrowDownIcon, ArrowUpIcon } from "@icons";
import styles from "./BoardSortDirection.module.scss";

export type BoardSortDirectionValue = "asc" | "desc";

const DIRECTION_OPTIONS = [
    { value: "asc", label: "Ascending", Icon: ArrowUpIcon },
    { value: "desc", label: "Descending", Icon: ArrowDownIcon },
] as const;

interface BoardSortDirectionProps {
    value: BoardSortDirectionValue;
    onValueChange: (value: BoardSortDirectionValue) => void;
    /** Turns the control off; the element with `reasonId` says why. */
    disabledReason?: string;
    reasonId: string;
}

/** Ascending and Descending, beside the Display popover's Sort picker. */
export const BoardSortDirection = ({
    value,
    onValueChange,
    disabledReason,
    reasonId,
}: Readonly<BoardSortDirectionProps>) => (
    <ToggleGroup.Root<BoardSortDirectionValue>
        value={value}
        onValueChange={(next) => next && onValueChange(next)}
        size="sm"
        aria-label="Sort direction"
        aria-describedby={disabledReason === undefined ? undefined : reasonId}
        disabled={disabledReason !== undefined}
        className={styles.direction}
    >
        {DIRECTION_OPTIONS.map(({ value: option, label, Icon }) => (
            <ToggleGroup.Item key={option} value={option} aria-label={label}>
                <Icon aria-hidden />
            </ToggleGroup.Item>
        ))}
    </ToggleGroup.Root>
);
